import { CDRoot } from "./CDRoot";
import { CDElement } from "./CDElement";
import { CDSelector } from "./CDSelector";
import { CDText } from "./CDText";
import { CDProperty } from "./CDProperty";
import { CDKeyFrames } from "./CDKeyFrames";
import { CDMediaQuery } from "./CDMediaQuery";

export class CDParser 
{
  _root:CDRoot;

  constructor( css:any ) 
  {
    this._root = new CDRoot( );
    this._parse( css, this._root );
  }

  get root( ) 
  {
    return this._root;
  }

  static readonly KeyFramesRegExp = /^@keyframes\s+((?:\w|\-|\_)+)/;
  static readonly MediaQueryRegExp = /^@media\s+/;


  private _isProperty( css:any, it:string )
  {
    let value = css[ it ];

  }


  private _parse( css:any, parent:CDElement ) 
  {
    for ( let it in css ) 
    {
      if ( css.hasOwnProperty( it ) ) 
      {
        let value = css[it];
        let type = typeof value;

        if ( ! CDProperty.isPropertyValue( css[ it ] ) && "object" === type ) 
        {
          if ( CDParser.KeyFramesRegExp.test( it ) )
          {
            let keyframesName = CDParser.KeyFramesRegExp.exec( it )[ 1 ];
            let keyframes = new CDKeyFrames( keyframesName );
            parent.appendChild( keyframes );
            this._parse( value, keyframes );            
          }
          else if ( CDParser.MediaQueryRegExp.test( it ) )
          {
            let queryValue = it.replace( CDParser.MediaQueryRegExp, "" ).trim();
            let mediaQuery = new CDMediaQuery( queryValue );
            parent.appendChild( mediaQuery );
            this._parse( value, mediaQuery );   
          }
          else
          {
            let selector = new CDSelector( it );
            parent.appendChild( selector );
            this._parse( value, selector );   
          }
       
        }
        else 
        {
          let isSpaceOnly = /^\s+$/.test( it );
          let isHTML = /_html_/.test( it );
          
          if ( isSpaceOnly || isHTML || it === "" ) 
          {
            let text = new CDText( value, isHTML );
            parent.appendChild( text );
          }
          else 
          {
            let property = new CDProperty( it, value );
            parent.appendChild( property );
          }
        }
      }
    }
  }
}